import psHttp from '@patsnap/common-ps-http';
import { emailAlertApiUrlPrefix } from '@cores/constants/envConfig';
export function getFolderEmailAlertStatusApi(folder_id) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/search?folder_id=${folder_id}`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || '';
    });
}
export function getEmailAlertListApi(params) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert`,
        method: 'GET',
        params,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || '';
    });
}
export function getEmailAlertLimitApi() {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/limitation`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || '';
    });
}
